import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M15.6 11.2371V7.71429C15.6 6.77143 14.79 6 13.8 6H4.8C3.81 6 3 6.77143 3 7.71429V16.2857C3 17.2286 3.81 18 4.8 18H13.8C14.79 18 15.6 17.2286 15.6 16.2857V13.2429L19.614 15.6857C20.217 16.0457 21 15.6429 21 14.9657V9.52286C21 8.84571 20.217 8.43429 19.614 8.80286L15.6 11.2371ZM12.9 16.2857H5.7C5.205 16.2857 4.8 15.9 4.8 15.4286V8.57143C4.8 8.1 5.205 7.71429 5.7 7.71429H12.9C13.395 7.71429 13.8 8.1 13.8 8.57143V15.4286C13.8 15.9 13.395 16.2857 12.9 16.2857ZM19.2 13.4314L17.193 12.24L19.2 11.0486C19.2 11.9571 19.2 12.5314 19.2 13.4314Z' />
        </SvgIcon>
    );
});
